/* EVERLA v2 "Atelier" — storefront behaviours. Header, search, cart drawer, quick view, variants, gallery, wishlist, collection ajax. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EV = window.EVERLA || {};
  document.documentElement.classList.add('js');

  /* ---------- utils ---------- */
  function money(cents, whole) {
    var fmt = EV.moneyFormat || '${{amount}}';
    if (whole) cents = Math.floor(Number(cents) / 100) * 100;
    var n = (cents / 100).toFixed(2); var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = whole || /amount_no_decimals/.test(fmt);
    return fmt.replace(/\{\{\s*amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/, noDec ? parts[0] : parts.join('.')).replace(/<[^>]+>/g, '');
  }
  // Hide only zero cents; fractional product prices must match the cart.
  function productMoney(cents) { return money(cents, Number(cents) % 100 === 0); }
  /* sale30 2026-10-19: announcement-v2 sets data-ev-sale="30" on <html> while the grand-opening sale runs (snippets/ev-promo.liquid).
     saleCents mirrors Shopify's percentage discount (cents - floor(cents * 30%): Shopify truncates the discount, 1299 -> 910 measured 2026-10-19); priceHtml is the same markup as snippets/ev-sale-price.liquid. */
  var SALE = parseInt(document.documentElement.getAttribute('data-ev-sale') || '0', 10) || 0;
  function saleCents(c) { c = Number(c) || 0; return SALE ? c - Math.floor(c * SALE / 100) : c; }
  function priceHtml(c, cmp) { c = Number(c) || 0; cmp = Number(cmp) || 0; if (SALE) return '<s class="ev-was">' + productMoney(c) + '</s> <span class="ev-now">' + productMoney(saleCents(c)) + '</span>'; return productMoney(c) + (cmp > c ? '<s>' + productMoney(cmp) + '</s>' : ''); }
  function toast(msg) {
    var t = $('.ev-toast');
    if (!t) { t = document.createElement('div'); t.className = 'ev-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('on'); clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }
  function json(url, opts) {
    opts = opts || {}; opts.headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function lock(on) { document.body.classList.toggle('ev-lock', !!on); }
  function imgSize(src, w) { if (!src) return ''; return src.replace(/(\.(jpe?g|png|webp|gif))(\?.*)?$/i, '_' + w + 'x$1$3'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }
  function debounce(fn, ms) { var h; return function () { var a = arguments, c = this; clearTimeout(h); h = setTimeout(function () { fn.apply(c, a); }, ms); }; }

  /* ---------- header: scroll state + transparent mode ---------- */
  var header = $('.ev-header');
  if (header) {
    var solidAt = header.classList.contains('is-transparent') ? 60 : 8, lastY = window.scrollY, hideAfter = 140, ticking = false;
    var paintHeader = function () {
      var y = window.scrollY;
      header.classList.toggle('is-solid', y > solidAt);
      if (document.body.classList.contains('ev-lock')) { ticking = false; return; }
      if (y > lastY + 4 && y > hideAfter) header.classList.add('is-hidden');
      else if (y < lastY - 4 || y <= solidAt) header.classList.remove('is-hidden');
      document.body.classList.toggle('ev-hdr-hidden', header.classList.contains('is-hidden'));
      lastY = y; ticking = false;
    };
    paintHeader();
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(paintHeader); } }, { passive: true });
  }

  /* ---------- announcement rotation ---------- */
  $$('.ev-annc').forEach(function (bar) {
    var msgs = $$('span', bar); if (msgs.length < 2) return;
    var i = 0, h; msgs[0].classList.add('is-on');
    var next = function () { msgs[i].classList.remove('is-on'); setTimeout(function () { i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, 320); };
    var start = function () { if (!reduce) h = setInterval(next, 5500); };
    start(); on(bar, 'mouseenter', function () { clearInterval(h); }); on(bar, 'mouseleave', start);
  });

  /* ---------- mobile drawer ---------- */
  var drawer = $('.ev-drawer'), scrim = $('.ev-scrim');
  var galleryZoomControllers = [];
  function openDrawer() { if (!drawer) return; hideAdded(); lastFocus = document.activeElement; drawer.classList.add('is-open'); $$('[data-ev-menu]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); }); if (scrim) scrim.classList.add('is-open'); lock(true); var f = $('a,button', drawer); if (f) f.focus(); }
  function closeAll() {
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} lastFocus = null; }
    galleryZoomControllers.forEach(function (entry) { entry.controller.close(); });
    if (drawer) drawer.classList.remove('is-open');
    $$('[data-ev-menu]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    $$('.ev-cart.is-open,.ev-filters.is-open,.ev-search.is-open,.ev-modal.is-open,.ev-zoom.is-open').forEach(function (p) { p.classList.remove('is-open'); });
    if (scrim) scrim.classList.remove('is-open'); lock(false);
  }
  $$('[data-ev-menu]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); openDrawer(); }); });
  $$('[data-ev-close]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); closeAll(); }); });
  on(scrim, 'click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !e.defaultPrevented) closeAll(); });

  /* ---------- search overlay + predictive ---------- */
  var search = $('.ev-search');
  if (search) {
    var sInput = $('input[type=search]', search), sRes = $('.ev-results', search), sDefault = sRes ? sRes.innerHTML : '';
    $$('[data-ev-search]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); hideAdded(); search.classList.add('is-open'); lock(true); setTimeout(function () { sInput && sInput.focus(); }, 30); }); });
    var lastQ = '';
    var run = debounce(function () {
      var q = (sInput.value || '').trim();
      if (q.length < 2) { sRes.innerHTML = sDefault; lastQ = ''; return; }
      if (q === lastQ) return; lastQ = q;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      json(url).then(function (d) {
        if ((sInput.value || '').trim() !== q) return;
        var r = d.resources.results, out = '';
        if (r.products && r.products.length) {
          out += '<div class="ev-eyebrow" style="margin-bottom:14px">Products</div><div class="ev-grid">' + r.products.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? imgSize(p.featured_image.url, 600) : '';
            return '<div class="ev-card"><a class="ph" href="' + esc(p.url) + '">' + (img ? '<img class="main" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a><div class="info"><span class="kick">' + esc(p.product_type || '') + '</span><a class="nm" href="' + esc(p.url) + '">' + esc(p.title) + '</a><div class="row"><span class="pr">' + priceHtml(Math.round(parseFloat(p.price) * 100)) + '</span></div></div></div>'; // sale30 2026-10-19
          }).join('') + '</div>';
        }
        var links = [];
        (r.collections || []).forEach(function (c) { links.push('<a href="' + esc(c.url) + '">' + esc(c.title) + ' →</a>'); });
        (r.pages || []).forEach(function (c) { links.push('<a href="' + esc(c.url) + '">' + esc(c.title) + ' →</a>'); });
        if (links.length) out += '<div class="ev-eyebrow" style="margin:28px 0 8px">Collections & pages</div><div class="ev-links">' + links.join('') + '</div>';
        out += '<div class="ev-hint" style="margin-top:28px"><a class="ev-link" href="' + root + 'search?q=' + encodeURIComponent(q) + '">See all results for “' + esc(q) + '”</a></div>';
        if (!out) out = '<p class="ev-hint">No matches for “' + esc(q) + '”. Try “rose”, “eucalyptus”, “vase”.</p>';
        sRes.innerHTML = out;
      }).catch(function () {});
    }, 220);
    on(sInput, 'input', run);
    on(sInput, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); var q = sInput.value.trim(); if (q) location.href = root + 'search?q=' + encodeURIComponent(q); } });
  }

  /* ---------- cart drawer ---------- */
  var cartEl = $('.ev-cart[role="dialog"]');
  var cartState = null;
  function paintCounts(n) { $$('.ev-count').forEach(function (b) { b.textContent = String(n); if (n > 0) b.removeAttribute('data-zero'); else b.setAttribute('data-zero', ''); }); $$('.cartn').forEach(function (b) { b.textContent = String(n); }); }
  /* Shipping estimate (snippets/ev-shipping-progress.liquid, 2026-10-11). cart.js has no tags and no shipping
     profiles, so Liquid computes the estimate and this copies the freshly rendered box ([data-ev-shipping]), the
     order-discount line ([data-ev-disc-row]) and the "Shipping" line ([data-ev-ship-row]) in from the re-rendered
     cart-drawer section. */
  var SHIP_SECTION = 'cart-drawer';
  function shipHtmlFrom(sections) {
    var h = sections && sections[SHIP_SECTION];
    return typeof h === 'string' ? h : null;
  }
  // No Accept: application/json here: Shopify then answers /cart with the cart object instead of the sections.
  function fetchShipSection() {
    return fetch(root + 'cart?sections=' + SHIP_SECTION)
      .then(function (r) { return r.ok ? r.json() : null; }).then(shipHtmlFrom).catch(function () { return null; });
  }
  /* The box is updated in place, never replaced: its message [data-ship-text] is the aria-live region, and a live
     region swapped in already filled is not announced. Attributes and the parts around the message are copied over;
     the message node itself stays and only its content changes, so screen readers read the new price. */
  function syncShipBox(el, next) {
    var live = $('[data-ship-text]', el), nextLive = $('[data-ship-text]', next);
    if (!live || !nextLive) { el.replaceWith(next.cloneNode(true)); return; }
    var i;
    for (i = el.attributes.length - 1; i >= 0; i--) { if (!next.hasAttribute(el.attributes[i].name)) el.removeAttribute(el.attributes[i].name); }
    for (i = 0; i < next.attributes.length; i++) { if (el.getAttribute(next.attributes[i].name) !== next.attributes[i].value) el.setAttribute(next.attributes[i].name, next.attributes[i].value); }
    Array.prototype.slice.call(el.children).forEach(function (c) { if (c !== live) el.removeChild(c); });
    var after = false;
    Array.prototype.slice.call(next.children).forEach(function (c) {
      if (c === nextLive) { after = true; return; }
      var copy = document.importNode(c, true);
      if (after) el.appendChild(copy); else el.insertBefore(copy, live);
    });
    live.hidden = false;
    if (live.innerHTML !== nextLive.innerHTML) live.innerHTML = nextLive.innerHTML;
  }
  function updateShippingProgress(cart, html) {
    var fresh = html ? new DOMParser().parseFromString(html, 'text/html') : null;
    ['[data-ev-shipping]', '[data-ev-disc-row]', '[data-ev-ship-row]'].forEach(function (sel) {
      var next = fresh && fresh.querySelector(sel);
      $$(sel).forEach(function (el) {
        if (next) { if (sel === '[data-ev-shipping]') syncShipBox(el, next); else el.replaceWith(next.cloneNode(true)); return; }
        /* No fresh section (network error): never leave a stale price or discount on screen. */
        if (sel === '[data-ev-disc-row]') { el.hidden = true; return; }
        el.hidden = !cart.item_count;
        var val = el.matches('[data-ev-ship-row]') ? el.lastElementChild : $('[data-ship-est-val]', el);
        if (val) val.textContent = 'At checkout';
        $$('[data-ship-text],[data-ship-progress]', el).forEach(function (x) { x.hidden = true; });
      });
    });
  }
  function renderCart(cart, shipHtml) {
    cartState = cart; paintCounts(cart.item_count); updateShippingProgress(cart, shipHtml);
    if (perfumeOffer) perfumeOffer.update(cart);
    if (!cartEl) return;
    var items = $('.items', cartEl), ft = $('.ft', cartEl), upsell = $('.upsell', cartEl);
    if (!cart.items.length) {
      items.innerHTML = '<div class="empty"><div class="ev-display">Nothing here yet</div><p>Your arrangement starts with one stem.</p><a class="ev-btn" href="' + root + 'collections/all" data-ev-close>Shop the collection</a></div>';
      if (ft) ft.hidden = true; if (upsell) upsell.hidden = false;
      $$('[data-ev-close]', items).forEach(function (b) { on(b, 'click', closeAll); });
      return;
    }
    if (ft) ft.hidden = false;
    items.innerHTML = cart.items.map(function (it) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' · ');
      return '<div class="line" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(imgSize(it.image, 200)) + '" alt="">' : '<span style="display:block;width:84px;height:104px;background:#fff;border:1px solid #EEE8E0"></span>') + '</a>' +
        '<div><a class="t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + (opts ? '<div class="v">' + opts + '</div>' : '') +
        '<div class="qty"><button type="button" data-q="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="Increase">+</button></div>' +
        '<button type="button" class="rm" data-rm>Remove</button></div>' +
        '<div class="pr">' + money(it.final_line_price) + (it.original_line_price > it.final_line_price ? '<br><s style="color:#8C9187;font-weight:400">' + money(it.original_line_price) + '</s>' : '') + '</div></div>';
    }).join('');
    $$('.line', items).forEach(function (line) {
      var key = line.getAttribute('data-key'); var it = cart.items.filter(function (x) { return x.key === key; })[0];
      $$('[data-q]', line).forEach(function (b) { on(b, 'click', function () { changeLine(key, it.quantity + parseInt(b.getAttribute('data-q'), 10)); }); });
      on($('[data-rm]', line), 'click', function () { changeLine(key, 0); });
    });
    var sub = $('[data-ev-subtotal]', cartEl); if (sub) sub.textContent = money(cart.items_subtotal_price);
    if (upsell) { var inCart = cart.items.map(function (i) { return String(i.variant_id); }); $$('.u', upsell).forEach(function (u) { u.hidden = inCart.indexOf(u.getAttribute('data-variant')) > -1; }); upsell.hidden = !$$('.u:not([hidden])', upsell).length; }
  }
  function loadCart() { return Promise.all([json(root + 'cart.js'), fetchShipSection()]).then(function (r) { renderCart(r[0], r[1]); }); }
  function changeLine(key, qty) { cartEl.classList.add('busy'); return json(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty), sections: SHIP_SECTION }) }).then(function (cart) { renderCart(cart, shipHtmlFrom(cart.sections)); }).catch(function (e) { toast((e && e.description) || 'Could not update the cart'); }).then(function () { cartEl.classList.remove('busy'); }); }
  var lastFocus = null;
  /* The bag opens by itself once per visit (2026-10-14, Diego: on phones the full-screen bag opened on every add and
     had to be closed to keep shopping). The first add of a visit opens it, so the shopper learns where items go; after
     that, and once the shopper has opened the bag themselves, an add updates the bag icon and shows a short
     "Added to your bag" note under the header instead (showAdded). An add made while the bag is open (its add-ons)
     keeps it open. Remembered per browser tab (sessionStorage); if storage is blocked, per page. */
  var BAG_SEEN = 'ev_bag_seen', bagSeenHere = false;
  function bagSeen() { if (bagSeenHere) return true; try { return sessionStorage.getItem(BAG_SEEN) === '1'; } catch (e) { return false; } }
  function markBagSeen() { bagSeenHere = true; try { sessionStorage.setItem(BAG_SEEN, '1'); } catch (e) {} }
  var addedEl = null, addedTimer = 0;
  var addedSr = document.createElement('p'); addedSr.className = 'ev-added-sr'; addedSr.setAttribute('role', 'status'); addedSr.setAttribute('aria-live', 'polite'); document.body.appendChild(addedSr);
  function hideAdded() { clearTimeout(addedTimer); if (addedEl) addedEl.classList.remove('is-on'); }
  function showAdded(items, req) {
    items = items || [];
    if (!addedEl) {
      addedEl = document.createElement('div'); addedEl.className = 'ev-added';
      addedEl.innerHTML = '<div class="im"></div><p class="tx"><b>Added to your bag</b><span></span></p><button type="button" class="vb">View bag</button>';
      document.body.appendChild(addedEl);
      on($('.vb', addedEl), 'click', function () { hideAdded(); openCart(); });
      var later = function () { clearTimeout(addedTimer); addedTimer = setTimeout(hideAdded, 2500); };
      on(addedEl, 'pointerenter', function (e) { if (e.pointerType === 'mouse') clearTimeout(addedTimer); }); on(addedEl, 'pointerleave', function (e) { if (e.pointerType === 'mouse') later(); });
      on(addedEl, 'focusin', function () { clearTimeout(addedTimer); }); on(addedEl, 'focusout', function (e) { if (!addedEl.contains(e.relatedTarget)) later(); });
    }
    /* Count from the request: /cart/add.js answers with each line's new total, not the amount just added. */
    var it = items[0], name = '', asked = (req || []).reduce(function (n, x) { return n + (parseInt(x.quantity, 10) || 0); }, 0);
    if (items.length > 1) name = (asked || items.length) + ' pieces';
    else if (it) name = it.product_title + (it.variant_title && it.variant_title !== 'Default Title' ? ' · ' + it.variant_title : '') + (asked > 1 ? ' × ' + asked : '');
    $('.tx span', addedEl).textContent = name;
    $('.im', addedEl).innerHTML = it && it.image && items.length === 1 ? '<img src="' + esc(imgSize(it.image, 120)) + '" alt="">' : '';
    /* Just under the header while it is on screen (it is sticky), else near the top. */
    var hd = $('.ev-header'), r = hd && hd.getBoundingClientRect();
    addedEl.style.top = Math.round(r && r.bottom > 0 ? r.bottom + 8 : 12) + 'px';
    $$('.ev-count').forEach(function (b) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); });
    addedEl.classList.add('is-on'); clearTimeout(addedTimer); addedTimer = setTimeout(hideAdded, 4500);
    addedSr.textContent = ''; setTimeout(function () { addedSr.textContent = 'Added to your bag' + (name ? ': ' + name : '') + '.'; }, 60);
  }
  /* Called after every successful add. Resolves 'refreshed' (bag was open), 'opened' (first add: bag opened) or 'noted'. */
  function afterAdd(items, req) {
    if (cartEl && cartEl.classList.contains('is-open')) return loadCart().then(function () {
      var a = document.activeElement; if ((!a || a === document.body) && !$('dialog[open]')) { var k = $('.hd button', cartEl); if (k) k.focus(); }
      return 'refreshed';
    });
    if (!cartEl || !bagSeen()) return loadCart().then(function () { openCart(); return 'opened'; });
    return loadCart().then(function () { showAdded(items, req); return 'noted'; });
  }
  function openCart() { markBagSeen(); hideAdded(); if (!cartEl) { location.href = root + 'cart'; return; } var openModal = $('.ev-modal.is-open'); if (!openModal || !lastFocus) lastFocus = document.activeElement; cartEl.classList.add('is-open'); if (scrim) scrim.classList.add('is-open'); lock(true); loadCart(); setTimeout(function () { var b = $('.hd button', cartEl); if (b) b.focus(); }, 60); }
  function addToCart(items) {
    return json(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (res) { if (cartPage) { location.reload(); return; } return afterAdd(res && res.items, items); })
      .catch(function (e) { toast((e && (e.description || e.message)) || 'Could not add to cart'); throw e; });
  }
  $$('[data-ev-cart]').forEach(function (b) { on(b, 'click', function (e) { if (document.body.classList.contains('template-cart')) return; e.preventDefault(); openCart(); }); });
  var perfumeOffer = window.EverlaPerfume ? window.EverlaPerfume.init(addToCart, {
    getCart: function () { return json(root + 'cart.js'); },
    add: function (items) { return json(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }); },
    beforeCheckout: function () {
      var note = $('[data-cart-note]');
      if (note) return json(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }
  }) : null;
  if (cartEl) loadCart();
  /* Card photo swatches keep the studio, lifestyle, link and purchase variant in sync. */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.ev-card .sw .dot'); if (!dot) return;
    e.preventDefault(); var card = dot.closest('.ev-card');
    $$('.sw .dot', card).forEach(function (d) { d.classList.remove('on'); d.setAttribute('aria-checked', 'false'); });
    dot.classList.add('on'); dot.setAttribute('aria-checked', 'true');
    var vid = $('[data-card-vid]', card); if (vid) vid.value = dot.getAttribute('data-vid');
    var pr = $('[data-card-price]', card); if (pr) { var cmp = parseInt(dot.getAttribute('data-compare') || '0', 10), p = parseInt(dot.getAttribute('data-price'), 10); pr.innerHTML = priceHtml(p, cmp); } // sale30 2026-10-19
    var img = dot.getAttribute('data-img'), main = $('.ph img.main', card); if (img && main) { main.srcset = ''; main.src = img; }
    var hoverSrc = dot.getAttribute('data-hover'), hover = $('.ph img.hov', card);
    card.setAttribute('data-lifestyle', hoverSrc ? 'true' : 'false');
    if (hover && hoverSrc) { hover.srcset = ''; hover.src = hoverSrc; }
    $$('.ph,.nm', card).forEach(function (link) { var url = new URL(link.href, location.origin); url.searchParams.set('variant', dot.getAttribute('data-vid')); link.href = url.href; });
    var add = $('[data-card-add]', card); if (add) { var ok = dot.getAttribute('data-avail') === 'true'; add.disabled = !ok; add.textContent = ok ? (add.getAttribute('data-label') || 'Add to cart') : 'Sold out'; }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-card-add]'); if (!b) return;
    e.preventDefault(); var card = b.closest('.ev-card'); var vid = $('[data-card-vid]', card); if (!vid || !vid.value) return;
    var label = b.textContent; b.disabled = true; b.textContent = 'Adding…';
    addToCart([{ id: parseInt(vid.value, 10), quantity: 1 }]).then(function () { b.textContent = 'Added'; setTimeout(function () { b.textContent = label; b.disabled = false; }, 1400); }, function () { b.textContent = label; b.disabled = false; });
  });

  /* recipe: add the whole arrangement */
  $$('[data-ev-recipe]').forEach(function (sec) {
    var btn = $('[data-recipe-add]', sec); if (!btn) return;
    on(btn, 'click', function () {
      var items = $$('[data-recipe-line]', sec).map(function (l) { var q = parseInt(($('input', l) || {}).value || l.getAttribute('data-qty') || '1', 10); return { id: parseInt(l.getAttribute('data-vid'), 10), quantity: Math.max(0, q) }; }).filter(function (i) { return i.id && i.quantity > 0; });
      if (!items.length) return; var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding the arrangement…';
      addToCart(items).then(function () { btn.textContent = 'Added — see your cart'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2000); }, function () { btn.textContent = label; btn.disabled = false; });
    });
    $$('[data-recipe-line]', sec).forEach(function (l) {
      var inp = $('input', l); if (!inp) return;
      $$('button[data-d]', l).forEach(function (b) { on(b, 'click', function () { var n = parseInt(inp.value, 10) || 0; n += b.getAttribute('data-d') === '-' ? -1 : 1; inp.value = Math.max(0, n); paintTotal(); }); });
      on(inp, 'input', paintTotal);
    });
    function paintTotal() { var t = 0; $$('[data-recipe-line]', sec).forEach(function (l) { var q = parseInt(($('input', l) || {}).value || '0', 10) || 0; t += q * parseInt(l.getAttribute('data-price'), 10); }); var el = $('[data-recipe-total]', sec); if (el) el.textContent = money(t); }
    paintTotal();
  });

  /* quick add buttons */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]'); if (!b) return;
    e.preventDefault(); b.disabled = true; var label = b.textContent;
    b.textContent = 'Adding…';
    addToCart([{ id: parseInt(b.getAttribute('data-quick-add'), 10), quantity: 1 }]).then(function () { b.textContent = 'Added'; setTimeout(function () { b.textContent = label; b.disabled = false; }, 1400); }, function () { b.textContent = label; b.disabled = false; });
  });
  /* product forms → ajax */
  function bindForm(form) {
    if (!form || form._ev) return; form._ev = true;
    on(form, 'submit', function (e) {
      e.preventDefault(); var btn = $('[type=submit]', form); var id = parseInt(($('input[name=id]', form) || {}).value, 10); var q = parseInt(($('input[name=quantity]', form) || { value: 1 }).value, 10) || 1;
      if (!id) return; var label = btn ? btn.textContent : ''; if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      addToCart([{ id: id, quantity: q }]).then(function (how) { if (btn) { btn.textContent = 'Added'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1400); } if (modal && modal.classList.contains('is-open')) closeQuickView(how !== 'opened'); }, function () { if (btn) { btn.textContent = label; btn.disabled = false; } });
    });
  }
  $$('form[data-ev-atc]').forEach(bindForm);

  /* ---------- variant picker (PDP + quick view) ---------- */
  function initProduct(scope) {
    var data = $('[data-ev-variants]', scope); if (!data) return;
    var variants; try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var galleryData = $('[data-ev-gallery-variants]', scope); var galleryMedia = {};
    if (galleryData) {
      try { var parsedGalleryMedia = JSON.parse(galleryData.textContent); if (parsedGalleryMedia && typeof parsedGalleryMedia === 'object' && !Array.isArray(parsedGalleryMedia)) galleryMedia = parsedGalleryMedia; } catch (e) {}
    }
    var quickViewImage = scope.classList.contains('ev-qv') ? $('.g .main', scope) : null;
    var form = $('form[data-ev-atc]', scope); bindForm(form);
    var idInput = form ? $('input[name=id]', form) : null;
    var opts = $$('.ev-opt', scope);
    var price = $('[data-ev-price]', scope), compare = $('[data-ev-compare]', scope), off = $('[data-ev-off]', scope);
    var atc = form ? $('[type=submit]', form) : null; var stock = $('[data-ev-stock]', scope);
    var sticky = scope.hasAttribute('data-ev-pdp') ? $('.ev-sticky-atc') : null, stickyPrice = sticky ? $('[data-ev-price]', sticky) : null;
    var unit = $('[data-ev-unit]', scope); var sku = $('[data-ev-sku]', scope);
    function selected() { return opts.map(function (o) { var v = $('.v.on', o); return v ? v.getAttribute('data-value') : null; }); }
    function find(sel) { return variants.filter(function (v) { return sel.every(function (s, i) { return s == null || v['option' + (i + 1)] === s; }); })[0]; }
    function markAvailability() {
      var sel = selected();
      opts.forEach(function (o, i) {
        $$('.v', o).forEach(function (b) {
          var probe = sel.slice(); probe[i] = b.getAttribute('data-value');
          var ok = variants.some(function (v) { return v.available && probe.every(function (s, j) { return s == null || v['option' + (j + 1)] === s; }); });
          b.classList.toggle('off', !ok);
        });
      });
    }
    function paint(v, push) {
      if (!v) { if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      /* sale30 2026-10-19: during the sale the price is the sale price, the struck figure the list price (or a higher real compare-at) and the label the sale's. */
      if (price) price.textContent = productMoney(saleCents(v.price));
      if (compare) { var was = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : (SALE ? v.price : 0); if (was) { compare.textContent = productMoney(was); compare.hidden = false; } else compare.hidden = true; }
      if (off) { if (SALE) { off.textContent = '30% off · Grand opening sale'; off.hidden = false; } else if (v.compare_at_price && v.compare_at_price > v.price) { off.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'; off.hidden = false; } else off.hidden = true; }
      if (stickyPrice) stickyPrice.textContent = productMoney(saleCents(v.price));
      if (sku) sku.textContent = v.sku || '';
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? (atc.getAttribute('data-label') || 'Add to cart') : (atc.getAttribute('data-soldout') || 'Sold out'); }
      if (stock) {
        stock.classList.toggle('out', !v.available);
        stock.classList.remove('low');
        var t = $('span', stock) || stock;
        t.textContent = v.available
          ? (stock.getAttribute('data-in') || 'Available to order')
          : (stock.getAttribute('data-out') || 'Unavailable');
      }
      /* SEEK, DO NOT REWRITE. Every image a colour can lead with is already a
         slide, so this moves `is-on` rather than swapping a src — the thumbnail
         follows, and a shopper who has clicked through to picture 3 is taken to
         the right one instead of watching slide 0 change off-screen. */
      var variantMedia = galleryMedia[String(v.id)];
      var galEl = $('.ev-gal', scope);
      // Liquid already chooses the initial photo, including direct variant links.
      // Seek variant media only after a shopper changes the selected option.
      if (push && variantMedia && variantMedia.mediaId != null && galEl && galEl.evGallery) {
        galEl.evGallery.showMedia(variantMedia.mediaId);
      }
      var quickViewMedia = (variantMedia && variantMedia.imageUrl ? { src: variantMedia.imageUrl, alt: v.name + ' — studio view' } : null) || v.featured_image || (v.featured_media && v.featured_media.preview_image);
      if (quickViewImage && quickViewMedia) {
        var quickViewSrc = quickViewMedia.src || quickViewMedia.url || (typeof quickViewMedia === 'string' ? quickViewMedia : '');
        if (quickViewSrc) {
          quickViewImage.removeAttribute('srcset');
          quickViewImage.setAttribute('src', quickViewSrc);
          quickViewImage.setAttribute('alt', quickViewMedia.alt || v.name || v.title || '');
          var quickViewStudio = String(quickViewMedia.alt || '').toLowerCase().indexOf('studio view') > -1;
          quickViewImage.classList.toggle('fill', quickViewStudio);
          quickViewImage.classList.toggle('editorial', !quickViewStudio);
        }
      }
      var detailLink = $('.ev-link.full', scope); if (detailLink) { var detailUrl = new URL(detailLink.href, location.origin); detailUrl.searchParams.set('variant', v.id); detailLink.href = detailUrl.href; }
      opts.forEach(function (o, i) { var lbl = $('.lb span', o); if (lbl) lbl.textContent = v['option' + (i + 1)]; });
      if (push && window.history && scope.hasAttribute('data-ev-pdp')) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      markAvailability();
    }
    opts.forEach(function (o) {
      $$('.v', o).forEach(function (b) {
        on(b, 'click', function () {
          $$('.v', o).forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); }); b.classList.add('on'); b.setAttribute('aria-pressed', 'true');
          var v = find(selected());
          if (!v) { var s = selected(); var idx = opts.indexOf(o); v = variants.filter(function (x) { return x['option' + (idx + 1)] === s[idx]; })[0]; if (v) opts.forEach(function (oo, i) { $$('.v', oo).forEach(function (x) { var onv = x.getAttribute('data-value') === v['option' + (i + 1)]; x.classList.toggle('on', onv); x.setAttribute('aria-pressed', onv ? 'true' : 'false'); }); }); }
          paint(v, true);
        });
      });
    });
    var current = variants.filter(function (v) { return String(v.id) === String(idInput ? idInput.value : ''); })[0] || variants[0];
    paint(current, false);
    /* qty */
    $$('.ev-qty', scope).forEach(function (q) { var inp = $('input', q); $$('button', q).forEach(function (b) { on(b, 'click', function () { var n = parseInt(inp.value, 10) || 1; n += b.getAttribute('data-d') === '-' ? -1 : 1; inp.value = Math.max(1, n); }); }); });
  }

  /* ---------- fixed PDP gallery zoom ---------- */
  /* ---------- gallery rail ----------
     Re-introduced after the four-tile cutover removed it. Thumbnails and slides
     are rendered from the SAME `{% for m in product.media %}`, so index k of one
     is index k of the other and `show(k)` needs no lookup. It also exposes
     showMedia(id) on the element, which is how picking a colour moves the big
     picture: the slide is already on the page, so nothing is ever re-fetched or
     rewritten — which is what used to leave the thumbnail showing the previous
     colour, and made a colour change look like nothing when the shopper was
     already on slide 3. */
  function initGallery(scope) {
    var gal = $('.ev-gal', scope); if (!gal) return null;
    if (gal.evGallery) return gal.evGallery;
    var thumbs = $$('.thumbs button', gal);
    var slides = $$('.stage > [data-media-id]', gal);
    if (!slides.length) return null;
    var i = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-on'); }));
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-on', k === i);
        var v = s.tagName === 'VIDEO' ? s : s.querySelector && s.querySelector('video');
        if (v && k !== i && v.pause) v.pause();
      });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === i);
        t.setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
      var t = thumbs[i]; if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    thumbs.forEach(function (t, k) { on(t, 'click', function () { show(k); }); });
    $$('.arrows button', gal).forEach(function (b) {
      on(b, 'click', function (e) { e.preventDefault(); e.stopPropagation(); show(i + (b.getAttribute('data-dir') === 'prev' ? -1 : 1)); });
    });
    on(gal, 'keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(i - 1); } else if (e.key === 'ArrowRight') { show(i + 1); }
    });
    var api = {
      show: show,
      showMedia: function (id) {
        if (id == null) return false;
        var k = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(id); });
        if (k < 0) return false;
        show(k); return true;
      }
    };
    gal.evGallery = api;
    return api;
  }

  function initGalleryZoom(scope) {
    if (!EV.productGallery || typeof EV.productGallery.initZoom !== 'function') return;
    destroyGalleryZooms(scope);
    var controller = EV.productGallery.initZoom(scope, { dialog: $('.ev-zoom'), lock: lock });
    galleryZoomControllers.push({ scope: scope, controller: controller });
  }
  function destroyGalleryZooms(container) {
    galleryZoomControllers = galleryZoomControllers.filter(function (entry) {
      var inside = entry.scope === container || (container && typeof container.contains === 'function' && container.contains(entry.scope));
      if (inside) entry.controller.destroy();
      return !inside;
    });
  }
  function initProductScope(scope) { initGallery(scope); initProduct(scope); initGalleryZoom(scope); }
  $$('[data-ev-product]').forEach(initProductScope);
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.matches && event.target.matches('[data-ev-product]')) initProductScope(event.target);
    $$('[data-ev-product]', event.target).forEach(initProductScope);
  });
  document.addEventListener('shopify:section:unload', function (event) { destroyGalleryZooms(event.target); });

  /* ---------- sticky ATC (mobile) ---------- */
  var sticky = $('.ev-sticky-atc'), mainAtc = $('[data-ev-pdp] .atc');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { es.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }); }).observe(mainAtc);
    on($('button', sticky), 'click', function () { var f = $('[data-ev-pdp] form[data-ev-atc]'); if (f) f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true })); });
  }

  /* ---------- quick view ---------- */
  var modal = $('.ev-modal[data-ev-quick]');
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-view]'); if (!b || !modal) return;
    e.preventDefault(); var handle = b.getAttribute('data-quick-view'); var panel = $('.panel .body', modal);
    hideAdded(); lastFocus = document.activeElement; panel.innerHTML = '<div class="ev-empty">Loading…</div>'; modal.classList.add('is-open'); lock(true); setTimeout(function () { var x = $('.x', modal); if (x) x.focus(); }, 60);
    var sourceCard = b.closest('[data-card]'), selectedVariant = sourceCard && $('[data-card-vid]', sourceCard);
    fetch(root + 'products/' + handle + '?view=quick' + (selectedVariant ? '&variant=' + encodeURIComponent(selectedVariant.value) : '')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'); var qv = $('[data-ev-product]', doc);
      if (!qv) { panel.innerHTML = '<div class="ev-empty">Could not load. <a class="ev-link" href="' + root + 'products/' + handle + '">Open the product page</a></div>'; return; }
      panel.innerHTML = ''; panel.appendChild(qv); initProduct(qv); initQvGallery(qv); bindWish(qv);
    }).catch(function () { panel.innerHTML = '<div class="ev-empty"><a class="ev-link" href="' + root + 'products/' + handle + '">Open the product page</a></div>'; });
  });
  function closeQuickView(restoreFocus) {
    var focusTarget = null;
    if (!modal) return;
    if (restoreFocus) { focusTarget = lastFocus; lastFocus = null; }
    else if (lastFocus && modal.contains(lastFocus)) lastFocus = null;
    modal.classList.remove('is-open');
    if (restoreFocus) {
      lock(false);
      if (focusTarget && focusTarget.focus) { try { focusTarget.focus(); } catch (e) {} }
    }
  }
  if (modal) on($('.x', modal), 'click', function () { closeQuickView(true); });
  on(modal, 'click', function (e) { if (e.target === modal) closeQuickView(true); });
  function initQvGallery(scope) { var main = $('.g .main', scope); $$('.g .thumbs button', scope).forEach(function (t) { on(t, 'click', function () { $$('.g .thumbs button', scope).forEach(function (x) { x.classList.remove('is-on'); }); t.classList.add('is-on'); if (main) { main.src = t.getAttribute('data-src'); main.classList.toggle('fill', t.getAttribute('data-fill') === '1'); main.classList.toggle('editorial', t.getAttribute('data-fill') !== '1'); } }); }); }

  /* ---------- wishlist (no account needed) ---------- */
  var WKEY = 'everla_wishlist';
  function wl() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wlSave(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} paintWish(); }
  function paintWish() { var a = wl(); $$('[data-wish]').forEach(function (b) { var onv = a.indexOf(b.getAttribute('data-wish')) > -1; b.classList.toggle('is-on', onv); b.setAttribute('aria-pressed', onv ? 'true' : 'false'); }); $$('[data-wish-count]').forEach(function (c) { c.textContent = String(a.length); if (a.length) c.removeAttribute('data-zero'); else c.setAttribute('data-zero', ''); }); }
  function bindWish(scope) { $$('[data-wish]', scope).forEach(function (b) { if (b._ev) return; b._ev = true; on(b, 'click', function (e) { e.preventDefault(); var h = b.getAttribute('data-wish'), a = wl(), i = a.indexOf(h); if (i > -1) { a.splice(i, 1); toast('Removed from your wishlist'); } else { a.push(h); toast('Saved to your wishlist'); } wlSave(a); }); }); }
  bindWish(document); paintWish();
  document.addEventListener('everla:cards-added', function (event) { bindWish(event.target); paintWish(); });
  var wlPage = $('[data-wishlist-page]');
  if (wlPage) {
    var a = wl(); var grid = $('.ev-grid', wlPage), empty = $('.ev-empty', wlPage);
    if (!a.length) { if (empty) empty.hidden = false; }
    else {
      Promise.all(a.map(function (h) { return json(root + 'products/' + h + '.js').catch(function () { return null; }); })).then(function (ps) {
        ps = ps.filter(Boolean); if (!ps.length) { if (empty) empty.hidden = false; return; }
        grid.innerHTML = ps.map(function (p) {
          var img = p.featured_image ? imgSize(p.featured_image, 800) : ''; var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          return '<div class="ev-card"><a class="ph" href="' + root + 'products/' + p.handle + '">' + (img ? '<img class="main" src="' + esc(img) + '" alt="' + esc(p.title) + '">' : '') + '</a><button class="wish is-on" type="button" data-wish="' + esc(p.handle) + '" aria-label="Remove from wishlist"><svg viewBox="0 0 24 24"><path d="M12 21s-7-4.6-9.3-9A5.2 5.2 0 0 1 12 6.5 5.2 5.2 0 0 1 21.3 12C19 16.4 12 21 12 21z"/></svg></button><div class="info"><span class="kick">' + esc(p.type || '') + '</span><a class="nm" href="' + root + 'products/' + p.handle + '">' + esc(p.title) + '</a><div class="row"><span class="pr">' + priceHtml(p.price) + '</span></div>' + (p.variants.length === 1 && v.available ? '<button class="ev-btn ev-btn--wide" type="button" style="margin-top:12px" data-quick-add="' + v.id + '">Add to cart</button>' : '<a class="ev-btn ev-btn--wide" style="margin-top:12px" href="' + root + 'products/' + p.handle + '">Choose options</a>') + '</div></div>';
        }).join('');
        bindWish(grid); paintWish();
        $$('[data-wish]', grid).forEach(function (b) { on(b, 'click', function () { setTimeout(function () { if (wl().indexOf(b.getAttribute('data-wish')) < 0) { var c = b.closest('.ev-card'); if (c) c.remove(); if (!$$('.ev-card', grid).length && empty) empty.hidden = false; } }, 10); }); });
      });
    }
  }

  /* ---------- recently viewed ---------- */
  var RKEY = 'everla_recent';
  var pdp = $('[data-ev-pdp]');
  if (pdp && pdp.getAttribute('data-handle')) { try { var r = JSON.parse(localStorage.getItem(RKEY) || '[]'); r = [pdp.getAttribute('data-handle')].concat(r.filter(function (h) { return h !== pdp.getAttribute('data-handle'); })).slice(0, 12); localStorage.setItem(RKEY, JSON.stringify(r)); } catch (e) {} }
  $$('[data-recent]').forEach(function (sec) {
    var r = []; try { r = JSON.parse(localStorage.getItem(RKEY) || '[]'); } catch (e) {}
    var skip = pdp ? pdp.getAttribute('data-handle') : null; r = r.filter(function (h) { return h !== skip; }).slice(0, 8);
    if (!r.length) { sec.hidden = true; return; }
    var track = $('.track', sec);
    Promise.all(r.map(function (h) { return json(root + 'products/' + h + '.js').catch(function () { return null; }); })).then(function (ps) {
      ps = ps.filter(Boolean); if (!ps.length) { sec.hidden = true; return; }
      // Right-sized like product-card-v2's carousel default: ~2x the card on phones (2026-10-08), not one 800px file.
      var rvSizes = '(max-width:749px) and (min-resolution:2.5dppx) 200px, (max-width:749px) and (-webkit-min-device-pixel-ratio:2.5) 200px, (max-width:749px) 74vw, (min-width:2000px) 635px, 33vw';
      track.innerHTML = ps.map(function (p) { var img = p.featured_image ? imgSize(p.featured_image, 600) : ''; var set = p.featured_image ? [400, 600, 900].map(function (w) { return esc(imgSize(p.featured_image, w)) + ' ' + w + 'w'; }).join(', ') : ''; return '<div class="ev-card"><a class="ph" href="' + root + 'products/' + p.handle + '">' + (img ? '<img class="main" src="' + esc(img) + '" srcset="' + set + '" sizes="' + rvSizes + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a><div class="info"><span class="kick">' + esc(p.type || '') + '</span><a class="nm" href="' + root + 'products/' + p.handle + '">' + esc(p.title) + '</a><div class="row"><span class="pr">' + priceHtml(p.price) + '</span></div></div></div>'; }).join(''); // sale30 2026-10-19
      sec.hidden = false;
    });
  });

  /* ---------- reveal on scroll ---------- */
  var rv = $$('.ev-reveal');
  if (rv.length && 'IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px 15% 0px', threshold: 0 });
    rv.forEach(function (el) { io.observe(el); });
  } else rv.forEach(function (el) { el.classList.add('is-in'); });

  /* ---------- carousels ---------- */
  $$('.ev-carousel').forEach(function (c) {
    var track = $('.track', c); if (!track) return;
    $$('.arr', c).forEach(function (b) { on(b, 'click', function () { var card = track.firstElementChild; var w = card ? card.getBoundingClientRect().width + 22 : 300; track.scrollBy({ left: (b.classList.contains('l') ? -1 : 1) * w * 2, behavior: reduce ? 'auto' : 'smooth' }); }); });
  });

  /* ---------- inline autoplay videos (editorial panels): play in view, pause off-screen ---------- */
  $$('video[autoplay]').forEach(function (v) {
    if (v.closest('.ev-hero')) return;
    v.muted = true; v.setAttribute('muted', '');
    if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
    var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) tryPlay(); else if (!v.paused) v.pause(); }); }, { rootMargin: '120px 0px', threshold: 0.05 }).observe(v);
    } else tryPlay();
  });

  /* ---------- tile films: a still until you hover, then it plays. No bytes until intent. ---------- */
  var finePointer = !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  $$('[data-hover-video]').forEach(function (tile) {
    var v = $('video.ev-film', tile); if (!v) return;
    if (!finePointer || reduce) { v.parentNode.removeChild(v); return; }
    var armed = false;
    function start() {
      if (!armed) { armed = true; var src = v.getAttribute('data-src'); if (!src) return; v.src = src; v.load(); }
      v.muted = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    function stop() { if (!v.paused) v.pause(); tile.classList.remove('is-playing'); }
    on(v, 'playing', function () { tile.classList.add('is-playing'); });
    on(v, 'pause', function () { tile.classList.remove('is-playing'); });
    on(tile, 'mouseenter', start);
    on(tile, 'mouseleave', stop);
    on(tile, 'focusin', start);
    on(tile, 'focusout', stop);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); });
    window.addEventListener('blur', stop);
  });

  /* ---------- hero video ---------- */
  $$('.ev-hero video').forEach(function (v) {
    v.muted = true; if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  });

  /* ---------- hotspots (shop the look) ---------- */
  $$('.ev-look').forEach(function (look) {
    var spots = $$('.ev-hotspot', look);
    function closeSpots() { spots.forEach(function (s) { s.classList.remove('is-open'); var c = $('#' + s.getAttribute('aria-controls')); if (c) c.classList.remove('is-open'); }); }
    spots.forEach(function (s) {
      on(s, 'click', function (e) {
        e.stopPropagation(); var open = s.classList.contains('is-open'); closeSpots(); if (open) return;
        s.classList.add('is-open'); var c = $('#' + s.getAttribute('aria-controls')); if (!c) return; c.classList.add('is-open');
        var x = parseFloat(s.style.left), y = parseFloat(s.style.top); c.style.left = (x > 60 ? 'auto' : 'calc(' + x + '% + 22px)'); c.style.right = (x > 60 ? 'calc(' + (100 - x) + '% + 22px)' : 'auto'); c.style.top = (y > 70 ? 'auto' : y + '%'); c.style.bottom = (y > 70 ? (100 - y) + '%' : 'auto');
      });
    });
    document.addEventListener('click', closeSpots);
  });

  /* ---------- collection: filters drawer, sort, ajax grid, load more (delegated) ---------- */
  var col = $('[data-ev-collection]');
  if (col) {
    var sectionId = col.getAttribute('data-section');
    var filters = $('.ev-filters'), form = filters ? $('form', filters) : null, loading = false;
    function currentCol() { return $('[data-ev-collection]') || col; }
    function syncTagFilterUrls() {
      // Shopify omits collection.filters for some empty tag combinations.
      // Keep query facets in tag links so changing style does not clear them.
      var current = new URL(location.href);
      var values = new URLSearchParams();
      current.searchParams.forEach(function (value, key) {
        if (key.indexOf('filter.') === 0) values.append(key, value);
      });
      $$('a[data-ev-tag-filter]').forEach(function (link) {
        var target = new URL(link.href, location.origin);
        values.forEach(function (value, key) { target.searchParams.delete(key); });
        values.forEach(function (value, key) { target.searchParams.append(key, value); });
        link.href = target.pathname + target.search;
      });
    }
    syncTagFilterUrls();
    function swap(url, push, append) {
      if (loading) return Promise.resolve(); loading = true; var c = currentCol(); c.classList.add('busy');
      var u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
      return fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'); var fresh = $('[data-ev-collection]', doc);
        if (!fresh) return;
        if (append) { var g = $('#pgrid', c), ng = $('#pgrid', doc); if (g && ng) { while (ng.firstChild) g.appendChild(ng.firstChild); } var m = $('.ev-more', c), nm = $('.ev-more', doc); if (m) { if (nm) m.replaceWith(nm); else m.remove(); } }
        else { c.innerHTML = fresh.innerHTML; }
        if (filters) { var nf = $('.ev-filters form', doc); if (nf && form) { form.innerHTML = nf.innerHTML; form.action = nf.action; } }
        var nu = new URL(url, location.origin); nu.searchParams.delete('section_id'); if (push) history.pushState({}, '', nu.toString());
        syncTagFilterUrls();
        bindWish(c); paintWish();
        if (!append) window.scrollTo({ top: c.getBoundingClientRect().top + window.scrollY - 140, behavior: reduce ? 'auto' : 'smooth' });
      }).catch(function () { location.href = url; }).then(function () { c.classList.remove('busy'); loading = false; });
    }
    document.addEventListener('click', function (e) {
      var f = e.target.closest('[data-ev-filters]'); if (f && filters) { e.preventDefault(); lastFocus = f; filters.classList.add('is-open'); if (scrim) scrim.classList.add('is-open'); lock(true); var fi = $('button,a,input:not([type=hidden])', filters); if (fi) fi.focus(); return; }
      var a = e.target.closest('[data-ev-collection] a[data-ev-ajax], .ev-filters a[data-ev-ajax]');
      if (a) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        if (loading) return;
        var finishLink = a.closest('.ev-bouquet-finishes');
        if (filters && filters.contains(a)) closeAll();
        swap(a.href, true).then(function () {
          if (finishLink) {
            var selected = $('.ev-bouquet-finishes [aria-current="true"]', currentCol());
            if (selected) selected.focus({ preventScroll: true });
          }
        });
        return;
      }
      var more = e.target.closest('[data-ev-more]'); if (more) { e.preventDefault(); more.disabled = true; more.textContent = 'Loading…'; swap(more.getAttribute('href'), true, true); return; }
      var clr = e.target.closest('[data-ev-clear]'); if (clr && form) { e.preventDefault(); swap(clr.getAttribute('data-ev-clear-url') || form.action, true); closeAll(); }
    });
    document.addEventListener('change', function (e) {
      var sort = e.target.closest('select[data-ev-sort]'); if (sort) { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); swap(u.toString(), true); }
    });
    if (form) {
      var applyForm = function () { var u = new URL(form.action, location.origin); var fd = new FormData(form); var params = new URLSearchParams(); fd.forEach(function (v, k) { if (v !== '') params.append(k, v); }); u.search = params.toString(); return swap(u.toString(), true); };
      on(form, 'change', debounce(applyForm, 350));
      on(form, 'submit', function (e) { e.preventDefault(); applyForm(); closeAll(); });
    }
    window.addEventListener('popstate', function () { swap(location.href, false); });
  }

  /* ---------- cart page ---------- */
  var cartPage = $('[data-ev-cartpage]');
  if (cartPage) {
    var change = function (key, qty) { cartPage.classList.add('busy'); json(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) }).then(function () { location.reload(); }).catch(function (e) { cartPage.classList.remove('busy'); toast((e && e.description) || 'Could not update the cart'); }); };
    $$('.line', cartPage).forEach(function (line) {
      var key = line.getAttribute('data-key'), q = parseInt(line.getAttribute('data-qty'), 10);
      $$('[data-q]', line).forEach(function (b) { on(b, 'click', function () { change(key, q + parseInt(b.getAttribute('data-q'), 10)); }); });
      on($('[data-rm]', line), 'click', function () { change(key, 0); });
    });
    var noteEl = $('[data-cart-note]', cartPage);
    if (noteEl) on(noteEl, 'change', function () { json(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: noteEl.value }) }).then(function () { toast('Note saved'); }).catch(function () {}); });
  }

  // Availability and newsletter forms use Shopify's native submission flow.
  // Shopify renders validation, spam challenges, and confirmed success states.

  /* ---------- share ---------- */
  $$('[data-ev-share]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); var d = { title: document.title, url: location.href }; if (navigator.share) navigator.share(d).catch(function () {}); else if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(function () { toast('Link copied'); }); }); });

  /* ---------- in-scale visual (parses "150 cm / 59 in tall") ---------- */
  $$('[data-ev-scale]').forEach(function (el) {
    var t = el.getAttribute('data-ev-scale') || ''; var m = t.match(/(\d+(?:\.\d+)?)\s*cm/i); var cm = m ? parseFloat(m[1]) : null;
    if (!cm) { var inch = t.match(/(\d+(?:\.\d+)?)\s*(?:in|")/i); if (inch) cm = parseFloat(inch[1]) * 2.54; }
    var bar = $('.bar', el); if (!bar || !cm) return;
    var h = Math.max(6, Math.min(118, cm / 170 * 90)); bar.setAttribute('height', h); bar.setAttribute('y', 110 - h);
    var w = cm > 120 ? 30 : cm > 60 ? 24 : 18; bar.setAttribute('width', w); bar.setAttribute('x', 65 - w / 2);
  });

  /* ---------- related products via the recommendations API ---------- */
  $$('[data-ev-related]').forEach(function (sec) {
    var url = sec.getAttribute('data-url'); if (!url) return;
    var load = function (u) { return fetch(u).then(function (r) { return r.text(); }).then(function (html) { var doc = new DOMParser().parseFromString(html, 'text/html'); return $('.ev-card', doc) ? $('.ev-wrap', doc) : null; }); };
    load(url).then(function (inner) { return inner || load(url.replace('intent=complementary', 'intent=related')); }).then(function (inner) {
      if (!inner) return; sec.innerHTML = ''; sec.appendChild(inner);
      $$('.ev-reveal', sec).forEach(function (el) { el.classList.add('is-in'); }); bindWish(sec); paintWish();
      $$('.ev-carousel', sec).forEach(function (c) { var track = $('.track', c); $$('.arr', c).forEach(function (b) { on(b, 'click', function () { var card = track.firstElementChild; var w = card ? card.getBoundingClientRect().width + 22 : 300; track.scrollBy({ left: (b.classList.contains('l') ? -1 : 1) * w * 2, behavior: 'smooth' }); }); }); });
    }).catch(function () {});
  });

  window.EVERLAv2 = { openCart: openCart, addToCart: addToCart, afterAdd: afterAdd, toast: toast, initProduct: initProduct };
})();
